import { Notification, Message } from 'element-ui';
import EventBus from '@/utils/event-bus';
import { get } from 'lodash';

export default function notifyOnReadableError(error) {
  const message = parseMessageFrom(error);
  if (!message) return null;

  return Notification.error({
    title: 'Error',
    dangerouslyUseHTMLString: true,
    message,
    duration: 0,
  });
}

EventBus.$on('flash:warning', (message) => {
  Message.warning({
    message,
    showClose: true,
    duration: 5000
  });
});

EventBus.$on('flash:error', (message) => {
  Message.error({
    message,
    showClose: true,
    duration: 5000
  });
});

EventBus.$on('notify:error', (message) => {
  Notification.error({
    dangerouslyUseHTMLString: true,
    message,
    duration: 0,
  });
});

function parseMessageFrom(error) {
  const parsers = [userMessage, serverError, networkError, otherError];

  const parser = parsers.find(parser => parser(error));
  return parser && parser(error);
}

function otherError(error) {
  return get(error, 'response.data.errors[0].detail')
      || get(error, 'response.data.errors[0]')
      || get(error, 'response.data.meta.error')
      || get(error, 'response.data.status');
}

function userMessage(error) {
  if (error.userMessage) return error.userMessage;

  return null;
}

function serverError(error) {
  const { message } = error;
  if (message && message.includes('status code 500')) return 'Sorry. An error has occured';

  return null;
}

function networkError(error) {
  if (error.message === 'Network Error') return error.message;

  return null;
}

